module.exports = __webpack_public_path__ + "img/logo-gentleman.7597d94b.jpg";